import {gql} from "@irati/utils/gql"

const fragment = gql`
  fragment wellnessMediaProvider on WellnessMediaProvider {
    uuid
    name
    description
    logo
  }
`

export const toString = fragment.loc.source.body

export default fragment
